/* eslint-disable unicorn/no-null */
import IUserProfileResponse from '#/types/API/userProfile';
import { AnyAction } from 'redux';
import {
  createActionProfileAddProfile,
  createActionProfileRemoveProfile,
} from '../actions/profile';

type TState = IUserProfileResponse | null;

const initialState: TState = null;

const profile = (state: TState = initialState, action: AnyAction): TState => {
  if (createActionProfileAddProfile.doesMatch(action)) {
    return { ...action.payload };
  }

  if (createActionProfileRemoveProfile.doesMatch(action)) {
    return null;
  }

  return state;
};

export default profile;
